module.exports = __webpack_public_path__ + "img/australia-other-heart-diseases-male.30992869.png";